import React from 'react';
import InfoPopupHeaderSetting from '../../components/InfoPopupHeaderSetting';
import DatePickerDisplay from '../../../Builder/DatePickerWidget/DateRangeDisplay/DatePickerDisplay';
import { MaybeNil } from '../../../../utils/interfaces';
import { IDatePickerFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { isNil } from 'lodash';

interface IProps {
  datePicker: MaybeNil<IDatePickerFieldsFragment>;
}

export default ({ datePicker }: IProps) => {
  if (isNil(datePicker)) {
    return null;
  }
  return (
    <InfoPopupHeaderSetting>
      <DatePickerDisplay datePicker={datePicker} />
    </InfoPopupHeaderSetting>
  );
};
